import { Image } from 'shared/types/image';

export const createImageId = (image: Image) =>
  image.id ?? image.createdAt.getTime().toString();
